// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Inter-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Inter-Variable.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/Inter-Variable.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter Variable";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2-variations"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff-variations"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 100 900;
  font-stretch: 50% 150%;
  font-display: swap;
}

/* VARIABLES
====================================================== */

:root {
  --c-accent-red: hsl(4, 85%, 63%);
  --c-accent-orange: hsl(40, 100%, 49%);
  --c-accent-lime: hsl(84, 54%, 46%);
  --c-accent-blue: hsl(216, 81%, 60%);
}

/* NORMALISE
====================================================== */

*,
*:before,
*:after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  max-width: 100%;
}

a {
  text-decoration: none;
  color: inherit;
}

ul,
ol,
li {
  list-style: none;
}

input,
textarea,
button,
select {
  font: inherit;
  color: inherit;
  background: none;
  border: none;
}

button {
  cursor: pointer;
}

hr {
  border: none;
}

dialog {
  font: inherit;
  color: inherit;
  border: none;
}

/* BASE
====================================================== */

html,
body {
  height: 100vh;
  font-family: "Inter Variable";
  font-weight: 350;
  color: #fff;
  background-color: cornflowerblue;
}

.container {
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.app {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 400px;
}

/* HEADER
====================================================== */

header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.19);
  backdrop-filter: blur(33px);
  -webkit-backdrop-filter: blur(33px);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    inset 0 -1px 0 rgba(255, 255, 255, 0.1);
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: rgb(23.1% 39.6% 70.2%);
  background-image: radial-gradient(
    circle at 10% 10%,
    rgb(23.1% 39.6% 70.2%) 14%,
    #1d7d78 41%,
    #257385 75%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.unit-form {
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  border-radius: 14px;
  padding: 4px;
  background-color: rgb(86, 132, 216);
}

.unit-option {
  cursor: pointer;
}

.unit-form input {
  display: none;
  opacity: 0;
  pointer-events: none;
}

.unit-option span {
  display: block;
  padding: 2px 10px;
  border-radius: 16px;
  font-weight: 500;
  color: #4b5563;
  transition:
    background 0.2s,
    color 0.2s;
}

.unit-option input:checked + span {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.unit-option input:focus-visible + span {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.location-form {
  display: flex;
  gap: 12px;
}

.location-input {
  flex-grow: 1;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(33px);
  -webkit-backdrop-filter: blur(33px);
}

.location-input::placeholder {
  font-size: 14px;
  color: hsl(260, 18%, 93%);
}

.location-input:focus {
  outline: none;
}

.location-form button {
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 15px;
  background-color: rgb(44, 85, 161);
  color: #fff;
}

/* WIDGET MAIN
====================================================== */

.widget {
  padding: 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.19);
  backdrop-filter: blur(33px);
  -webkit-backdrop-filter: blur(33px);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    inset 0 -1px 0 rgba(255, 255, 255, 0.1),
    inset 0 0 8px 4px rgba(255, 255, 255, 0.4);
}

.info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: hsl(260, 24%, 93%);
}

.location {
  font-size: 18px;
  font-weight: 400;
  text-transform: capitalize;

}

.weather-conditions {
  display: flex;
  margin-top: -12px;
}

.icon {
  margin-left: -12px;
  height: 160px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.temp {
  font-size: 32px;
}

/* WEATHER DETAILS
====================================================== */

.weather-details {
  display: flex;
  justify-content: space-between;
}

.weather-details .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.weather-details h4 {
  font-size: 14px;
  font-weight: 400;
  color: hsl(260, 24%, 93%);
}

.weather-details p {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B;;;8DAGuD;EACvD,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;wDACwD;;AAExD;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;wDACwD;;AAExD;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;wDACwD;;AAExD;;EAEE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;wDACwD;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC;;;2CAGyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B;;;;;GAKC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd;;cAEY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,WAAW;AACb;;AAEA;wDACwD;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC;;;;8CAI4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;;AAE5B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;wDACwD;;AAExD;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: \"Inter Variable\";\n  src:\n    url(\"./assets/Inter-Variable.woff2\") format(\"woff2-variations\"),\n    url(\"./assets/Inter-Variable.woff\") format(\"woff-variations\"),\n    url(\"./assets/Inter-Variable.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-stretch: 50% 150%;\n  font-display: swap;\n}\n\n/* VARIABLES\n====================================================== */\n\n:root {\n  --c-accent-red: hsl(4, 85%, 63%);\n  --c-accent-orange: hsl(40, 100%, 49%);\n  --c-accent-lime: hsl(84, 54%, 46%);\n  --c-accent-blue: hsl(216, 81%, 60%);\n}\n\n/* NORMALISE\n====================================================== */\n\n*,\n*:before,\n*:after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nul,\nol,\nli {\n  list-style: none;\n}\n\ninput,\ntextarea,\nbutton,\nselect {\n  font: inherit;\n  color: inherit;\n  background: none;\n  border: none;\n}\n\nbutton {\n  cursor: pointer;\n}\n\nhr {\n  border: none;\n}\n\ndialog {\n  font: inherit;\n  color: inherit;\n  border: none;\n}\n\n/* BASE\n====================================================== */\n\nhtml,\nbody {\n  height: 100vh;\n  font-family: \"Inter Variable\";\n  font-weight: 350;\n  color: #fff;\n  background-color: cornflowerblue;\n}\n\n.container {\n  height: 90%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 400px;\n}\n\n/* HEADER\n====================================================== */\n\nheader {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 24px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.19);\n  backdrop-filter: blur(33px);\n  -webkit-backdrop-filter: blur(33px);\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: rgb(23.1% 39.6% 70.2%);\n  background-image: radial-gradient(\n    circle at 10% 10%,\n    rgb(23.1% 39.6% 70.2%) 14%,\n    #1d7d78 41%,\n    #257385 75%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.unit-form {\n  display: grid;\n  grid-template: 1fr / 1fr 1fr;\n  border-radius: 14px;\n  padding: 4px;\n  background-color: rgb(86, 132, 216);\n}\n\n.unit-option {\n  cursor: pointer;\n}\n\n.unit-form input {\n  display: none;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.unit-option span {\n  display: block;\n  padding: 2px 10px;\n  border-radius: 16px;\n  font-weight: 500;\n  color: #4b5563;\n  transition:\n    background 0.2s,\n    color 0.2s;\n}\n\n.unit-option input:checked + span {\n  background: #fff;\n  color: #111827;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.unit-option input:focus-visible + span {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.location-form {\n  display: flex;\n  gap: 12px;\n}\n\n.location-input {\n  flex-grow: 1;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(33px);\n  -webkit-backdrop-filter: blur(33px);\n}\n\n.location-input::placeholder {\n  font-size: 14px;\n  color: hsl(260, 18%, 93%);\n}\n\n.location-input:focus {\n  outline: none;\n}\n\n.location-form button {\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 15px;\n  background-color: rgb(44, 85, 161);\n  color: #fff;\n}\n\n/* WIDGET MAIN\n====================================================== */\n\n.widget {\n  padding: 24px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.19);\n  backdrop-filter: blur(33px);\n  -webkit-backdrop-filter: blur(33px);\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 0 8px 4px rgba(255, 255, 255, 0.4);\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: hsl(260, 24%, 93%);\n}\n\n.location {\n  font-size: 18px;\n  font-weight: 400;\n  text-transform: capitalize;\n\n}\n\n.weather-conditions {\n  display: flex;\n  margin-top: -12px;\n}\n\n.icon {\n  margin-left: -12px;\n  height: 160px;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 12px;\n}\n\n.temp {\n  font-size: 32px;\n}\n\n/* WEATHER DETAILS\n====================================================== */\n\n.weather-details {\n  display: flex;\n  justify-content: space-between;\n}\n\n.weather-details .wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.weather-details h4 {\n  font-size: 14px;\n  font-weight: 400;\n  color: hsl(260, 24%, 93%);\n}\n\n.weather-details p {\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
